import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuditFilters, AuditQueryParams } from '../audit-trail.model';
import { FilterRange, FormHelper } from 'common';
import moment from "moment";
import { AuditTrailService } from '../audit-trail.service';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-audit-trail-list-filter-dialog',
    templateUrl: './audit-trail-list-filter-dialog.component.html',
    standalone: false
})
export class AuditTrailListFilterDialogComponent implements OnInit {
  form: UntypedFormGroup;
  minDateTo: Date;
  maxDateFrom: Date;

  constructor(public dialogRef: MatDialogRef<AuditTrailListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
    private auditService: AuditTrailService
  ) {
    this.form = this.formBuilder.group({
      date: this.data.query.dateFrom || undefined,
      dateFrom: new UntypedFormControl(this.data.query.dateFrom ? new Date(this.data.query.dateFrom) : undefined, { validators: null, updateOn: 'blur' }),
      dateTo: new UntypedFormControl(this.data.query.dateTo ? new Date(this.data.query.dateTo) : undefined, { validators: null, updateOn: 'blur' }),
      event: this.data.query.eventName ? this.getEventNameData() : '',
      initiator: this.data.query.initiator || undefined
    });
  }

  ngOnInit(): void {
    this.updateDateLimits();
    this.form.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(() => this.updateDateLimits());
  }

  dateSelected(dataRange: FilterRange<moment.Moment>): void {
    this.form.patchValue({
      dateFrom: dataRange.from,
      dateTo: dataRange.to
    });
  }

  getEventNameData(): void {
    this.auditService.hints({
      eventName: this.data.query.eventName,
    }).pipe(untilDestroyed(this))
      .subscribe(res => {
        this.form.controls.event.setValue(res[0]);
      });
  }

  static show(dialog: MatDialog, query: AuditQueryParams): Observable<any> {
    return dialog.open(AuditTrailListFilterDialogComponent, {
      data: { query },
      closeOnNavigation: true,
    }).afterClosed();
  }

  onConfirmed(formValues: unknown): void {
    // A typed-in reversed range fails the pickers' min/max validation; the API rejects it too.
    if (this.form.invalid) {
      FormHelper.showInvalidFormFields(this.form);
      return;
    }

    this.dialogRef.close(new AuditFilters(formValues));
  }

  private updateDateLimits(): void {
    const { dateFrom, dateTo } = this.form.getRawValue();
    this.minDateTo = dateFrom ? moment(dateFrom).toDate() : undefined;
    this.maxDateFrom = dateTo ? moment(dateTo).toDate() : undefined;
  }
}
